/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearCookie } from '../helper/lib';
import { useNavigate } from 'react-router-dom';
import { logout, getProfile } from '../services';
import {
  changeLoading,
  changeDataNotification,
  changeDataProfile,
  changeQbNewMessage,
  changeQbSession,
  changeQbUnread,
  changeMode,
} from '../store';
import MailIcon from '../assets/img/custom/mail.svg';
import PhoneIcon from '../assets/img/custom/phone.svg';
import Logo from '../assets/img/logo_kisahruang.png';

const Caution = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dataProfile } = useSelector((state) => state.global);

  const clearData = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log('Service Worker unregistered successfully.');
            }
          });
        });
      });
    }

    window.indexedDB.deleteDatabase('firebase-heartbeat-database');
    window.indexedDB.deleteDatabase('firebase-installations-database');
    window.indexedDB.deleteDatabase('firebase-messaging-database');
    localStorage.clear();
    clearCookie('token');

    dispatch(changeQbNewMessage(null));
    dispatch(changeDataNotification(null));
    dispatch(changeDataProfile(null));
    dispatch(changeLoading(false));
    dispatch(changeQbSession(null));
    dispatch(changeQbUnread(null));
    changeMode(null);
    navigate('/');
  };

  const handleLogout = async () => {
    try {
      const response = await logout();
      if (response.message === 'Success') {
        clearData();
      }
    } catch (e) {
      console.error('error:', e);
    }
  };

  const getUserData = async () => {
    try {
      const response = await getProfile();
      if (response.message === 'Success') {
        dispatch(changeDataProfile(response.data));
      }
    } catch (error) {
      console.error(
        'error:',
        error?.response?.data?.message ?? 'Something went wrong'
      );
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (dataProfile) {
      if (dataProfile?.status === 'APPROVED') {
        navigate('/');
      }
    }
  }, [dataProfile]);

  return (
    <div className="wrap-content signin">
      <div className="row h-100">
        <div className="col-12 h-100 position-relative form-parent">
          <div className="d-flex align-items-center justify-content-center form-wrap px-5 px-md-0">
            <div>
              <div className="d-flex align-items-center justify-content-center mb-3 head">
                <div className="login--logo-container">
                  <img src={Logo} alt="img-logo" />
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center mb-3">
                <span className="pe-1 text-gray fs-3 text-center fw-bold">
                  Welcome Back!
                </span>
              </div>

              <div className="d-flex align-items-center justify-content-center mb-3">
                <span className="pe-1 text-gray text-center fz-14">
                  This account waiting approval.
                </span>
              </div>

              <div className="my-4 d-flex flex-row justify-content-center">
                <button
                  type="button"
                  className="link-dark fw-semibold btn-fill px-3 py-1 rounded"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>

              <div className="d-flex align-items-center justify-content-center mb-1">
                <span className="pe-1 text-gray text-center fw-bold">
                  Our Contacts
                </span>
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <img className="icon-3 me-1" src={MailIcon} alt="img-mail" />
                <span className="pe-1 text-secondary text-center fz-14">
                  admin@kisahruang.com
                </span>
              </div>

              <div className="ps-sm-3 pt-1 pt-sm-0 d-flex align-items-center justify-content-center">
                <img className="icon-3 me-1" src={PhoneIcon} alt="img-phone" />
                <span className="pe-1 text-secondary text-center fz-14">
                  08119998999
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Caution;
